import { TextArea } from "components/core"
import { FormikProps } from "formik"
import { FC } from "react"

interface CancelServiceOrderFormProps {
  form: FormikProps<{
    cancellationReason: string;
  }>;
}

export const CancelSuspectedIllegalityForm: FC<CancelServiceOrderFormProps> = ({ form }) => {

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Cancellation Reason</span>
        <div className="grid gap-6 mt-2">
          <div>
            <TextArea
              id="cancellationReason"
              label="Reason"
              placeholder="e.g. Reason for cancellation"
              required={true}
              rows={10}
              {...form}
            />
          </div>

        </div>
      </div>
    </div>
  )
}

export default CancelSuspectedIllegalityForm